<template>
    <div class="row div-spacing-top">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="order-title">
                Frame Information
            </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
            <div class="row no-margin order-div">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <p>
                        Please select the order type from the icons below.*
                    </p>
                </div>
                <div v-for="(jt, index) in JobType" :key="index" class="center" :class="{ 'col-sm-4': JobType.length == 3, 'col-sm-6': JobType.length == 2 }">
                    <label class="g-font-size-20">{{jt.description}}</label>
                    <div v-on:click="CheckVal(jt.type)" class="image-div">
                        <img v-if="Order.JobType != jt.type" class="img-fluid" :src="jt.imageURL">
                        <img v-else class="img-fluid" :src="jt.invertedImageURL">
                    </div>
                    <input :disabled="isChangeJobTypeDisabled" @change="CheckVal(jt.type)" type="radio" name="frameJobtype" :value="jt.type" v-model="Order.JobType">
                </div>
                <div v-if="ValidationResult.OrderJobType" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <p class="error-message" v-if="ValidationResult.OrderJobType">{{ValidationResult.OrderJobType}}</p>
                </div>
            </div>
        </div>
        <div v-if="(Order.JobType =='FTC') || (Order.JobType =='UNC')" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
            <div class="row no-gutters order-div">
                <p>Please enter as much information as possible to assist the lab in correctly identifying the frame.</p>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 input-space-right">
                    <div class="form-group">
                        <label>Manufacturer</label>
                        <input v-model="Order.FrameManufacturer" type="text" class="form-control" placeholder="i.e. FGX">
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 input-space-left">
                    <div class="form-group">
                        <label class="login_info_label">Brand</label>
                        <input v-model="Order.FrameBrand" type="text" class="form-control" placeholder="i.e. Lantis">
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 input-space-right">
                    <div class="form-group">
                        <label class="login_info_label">Model</label>
                        <input v-model="Order.FrameModel" type="text" class="form-control" placeholder="i.e. Sidekick, L00015, or Strike/L00132">
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 input-space-left">
                    <div class="form-group">
                        <label>Frame Type<span v-if="(Order.JobType =='FTC')">*</span></label>
                        <select v-model="Order.FrameType" v-bind:class="{ error_field: ValidationResult.OrderFrameType }" class="form-control" style="height: 36.5px;">
                            <option v-for="ft in FrameType" v-bind:value="ft.code">{{ft.name}}</option>
                        </select>
                        <p class="error-message" v-if="ValidationResult.OrderFrameType">{{ValidationResult.OrderFrameType}}</p>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 input-space-right">
                    <div class="form-group">
                        <label class="login_info_label">Color</label>
                        <input v-model="Order.FrameColor" v-bind:class="{ error_field: ValidationResult.OrderFrameColor }" type="text" class="form-control" placeholder="i.e. Tortoise, Red">
                        <p class="error-message" v-if="ValidationResult.OrderFrameColor">{{ValidationResult.OrderFrameColor}}</p>
                    </div>
                </div>
              <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 input-space-left input-space-right">
                    <div class="form-group">
                        <label class="login_info_label">Eye Size<span v-if="((Order.JobType =='FTC' || Order.JobType =='UNC') && !Order.FrameCheckMeasurements)">*</span> <span style="font-size: small; font-weight: normal;">(A-box)</span> </label>
                        <input v-model="Order.FrameEyeSize" v-bind:class="{ error_field: ValidationResult.OrderFrameEyeSize }" type="number" class="form-control" placeholder="i.e. 50">
                        <p class="error-message" v-if="ValidationResult.OrderFrameEyeSize">{{ValidationResult.OrderFrameEyeSize}}</p>
                    </div>
                </div>
                  <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 input-space-left input-space-right">
                    <div class="form-group">
                      <label class="login_info_label">DBL<span v-if="((Order.JobType =='UNC' ||  Order.JobType =='FTC') && !Order.FrameCheckMeasurements)">*</span></label>
                        <input v-model="Order.FrameDBL" v-bind:class="{ error_field: ValidationResult.OrderFrameDBL }" type="number" class="form-control" placeholder="i.e. 15">
                      <p class="error-message" v-if="ValidationResult.OrderFrameDBL">{{ValidationResult.OrderFrameDBL}}</p>
                    </div>
                </div>
                <div v-if="(Order.JobType =='UNC')" class="col-lg-2 col-md-2 col-sm-12 col-xs-12 input-space-left input-space-right">
                    <div class="form-group">
                      <label class="login_info_label">B-Box<span v-if="(Order.JobType =='UNC' && !Order.FrameCheckMeasurements)">*</span></label>
                        <input v-model="Order.FrameBBox" v-bind:class="{ error_field: ValidationResult.OrderFrameBBox }" type="number" max="30" class="form-control" placeholder="i.e. 25">
                         <p class="error-message" v-if="ValidationResult.OrderFrameBBox">{{ValidationResult.OrderFrameBBox}}</p>
                    </div>
                </div>
                <div v-if="(Order.JobType =='UNC')" class="col-lg-2 col-md-2 col-sm-12 col-xs-12 input-space-left input-space-right">
                    <div class="form-group">
                      <label class="login_info_label">ED<span v-if="(Order.JobType =='UNC' && !Order.FrameCheckMeasurements)">*</span></label>
                        <input v-model="Order.FrameED" v-bind:class="{ error_field: ValidationResult.OrderFrameED }" type="number" class="form-control" placeholder="i.e. 50">
                         <p class="error-message" v-if="ValidationResult.OrderFrameED">{{ValidationResult.OrderFrameED}}</p>
                    </div>
                </div>
                <div v-if="(Order.JobType =='FTC')" class="col-lg-2 col-md-2 col-sm-12 col-xs-12 input-space-left">
                    <div class="form-group">
                        <label class="login_info_label">Temple Length</label>
                        <input v-model="Order.FrameTempleLength" type="number" class="form-control" placeholder="i.e. 140">
                    </div>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"></div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top" v-if="!Order.IsExamOnly">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <p>Frame Measurements:
                      <span data-balloon="Click this button to view how to find your measurements" data-balloon-pos="down" data-balloon-length="large">
                      <span v-on:click="ShowFrameSizeModal()">
                        <i class="fa fa-question-circle-o"></i>
                      </span>
                    </span>
                    </p>
                  </div>
                  <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-check">
                          <input v-model="Order.FrameCheckMeasurements" :value="Order.FrameCheckMeasurements"  type="checkbox" v-on:click="ClickNoFrameMeasurements()" class="form-check-input">
                          <label class="form-check-label">I dont have frame measurements (may result in thicker lens)</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>

        <div v-if="Order.JobType == 'LSF' && (this.framePageVisible == 'true' || MasterAccountType == 'master')" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
            <div class="row no-gutters order-div">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="form-group order-div order-div">
                        <label>Select Your Frame*</label>
                        <multiselect v-model="CurrentFrameAndLens" v-bind:class="{ error_select: ValidationResult.OrderFrameId }" @input="FrameAndLensValue(false)" :custom-label="customLabel" :options="FrameAndLens" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" ">
                            <span slot="noResult">No elements found.</span>
                            <template slot="option" slot-scope="props">
                                <span>Name/Model: {{ props.option.name }} - Color: {{ props.option.color }} - Eyesize: {{ props.option.eyeSize }} - Frame Type: {{ props.option.frameType }}  {{props.option.catalogId ? '- Catalog -' +  ConvertToTitleCase(props.option.catalogId) : ''}}</span>
                                <span class="pull-right stock-text">
                                    <span v-if="props.option.isOutOfStock || props.option.isLowStock">Low Stock</span>
                                </span>
                            </template>
                        </multiselect>
                        <p class="error-message" v-if="ValidationResult.OrderFrameId">{{ValidationResult.OrderFrameId}}</p>
                    </div>
                </div>
                <div v-if="CurrentFrameAndLens" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="row">
                        <div class="col-lg-11 col-md-11 col-sm-12 col-xs-12 v-">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                    <div class="image-div-frame">
                                        <img v-on:error="ImageExists(CurrentFrameAndLens)" class="img-fluid image-icon" v-bind:src="CurrentFrameAndLens.frontImageURL">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                    <p>Model Name/#: {{CurrentFrameAndLens.name}}</p>
                                    <p>Color: {{CurrentFrameAndLens.color}}</p>
                                    <p>Measurements: {{CurrentFrameAndLens.eyeSize}} - {{CurrentFrameAndLens.dbl}} - {{CurrentFrameAndLens.templeLength}}</p>
                                </div>
                                <div class="col-lg-4 col-md-5 col-sm-12 col-xs-12">
                                    <p>Frame Type: {{CurrentFrameAndLens.frameType}}</p>
                                    <p>Manufacturer: {{CurrentFrameAndLens.manufacturer}}</p>
                                    <p>Brand: {{CurrentFrameAndLens.frameBrand}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <p class="warning-text-color" v-if="((Capping.frameLensCap - Capping.frameLensCount) <= Capping.frameLensThreshold) && (Capping.frameLensCount < Capping.frameLensCap) && (MasterAccountType != 'master') && Capping.isFrameLensCapOn">
                        You have {{Capping.frameLensCap - Capping.frameLensCount}} frame & lens orders remaining on your account. After that number is reached you will no longer be able to place frame & lens orders. For more information,
                        <a style="text-decoration: underline;" @click="OpenHelpForm()">contact us.</a>
                    </p>
                    <p class="error-message" v-if="(Capping.frameLensCount >= Capping.frameLensCap) && (MasterAccountType != 'master') && Capping.isFrameLensCapOn">
                        You have reached your Frame and Lens limit and are no longer able to submit these orders. For more information,
                        <a style="text-decoration: underline;" @click="OpenHelpForm()">contact us.</a>
                    </p>
                    <p class="lsf-payment" v-if="(Capping.frameLensCount < Capping.frameLensCap) && (MasterAccountType != 'master') && Capping.isFrameLensCapOn && isFrameLensServiceFee">
                        <b>Please Note:</b> After you submit, you will be charged a service fee for this order.
                    </p>
                </div>
            </div>
        </div>

        <div v-if="isModalShown">
            <div class="modal-mask" role="dialog">
                <div class="overlay-mask">
                    <div class="modal-dialog modal-xl">
                        <div class="modal-content">
                            <div class="modal-body">
                                <div class="close_btn" v-on:click="CloseOOSModal()"></div>
                                <div v-if="isFormLoading" class="row text-center">
                                    <page-loader></page-loader>
                                </div>
                                <div v-else class="g-mt-20 g-mx-20">
                                    <div v-if="suggestedFrameList.length == 0">
                                        <div class="container-fluid">
                                            <h1>Out of Stock</h1>
                                            <p>Sorry, this frame is out of stock. Please select another.</p>
                                            <div class="row">
                                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center g-my-10">
                                                    <button class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-mx-10 g-my-10" v-on:click="CloseOOSModal()">Close</button>
                                                </div>
                                            </div>
                                        </diV>
                                    </div>
                                    <div v-else class="row">
                                        <div class="container-fluid">
                                            <h1>Out of Stock</h1>
                                            <p>Sorry, the frame you selected is no longer available. Please select another frame from below, or click the X to return to the order.</p>
                                            <hr>
                                        </div>
                                        <div v-for="(frame, key) in suggestedFrameList" :key="key" class="col-lg-3 g-mb-30 g-py-5">
                                            <article>
                                                <div class="gray-border">
                                                    <div v-if="frame.imageUrl != null || frame.imageUrl != 'NULL'" class="location_img swiper-slide">
                                                        <div class="frame-pic-div" style="height: 150px">
                                                            <img class="img-fluid image-align-vert-hor" v-on:error="ImageExists(frame)" v-bind:src="frame.frontImageURL" alt="Image Description">
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="g-pa-15 gray-border">
                                                    <label class="g-font-weight-600 frame-label">Name:</label>
                                                    <span class="frame-description">{{frame.name}}</span><br>
                                                    <label class="g-color-text g-font-weight-500 mb-1 frame-label">Color: </label>
                                                    <span>{{frame.color}}</span>
                                                    <br>
                                                    <label class="g-color-text g-font-weight-500 frame-label mb-1">Frame Type: </label>
                                                    <span class="g-color-text frame-description mb-1">{{frame.frameType}} </span>
                                                    <br>
                                                    <label class="g-color-text g-font-weight-500 frame-label mb-1">Measurements: </label>
                                                    <br>
                                                    <span class="frame-description">{{frame.eyeSize}} - {{frame.dbl}} - {{frame.templeLength}}</span>
                                                    <br>
                                                </div>
                                                <div class="g-pa-15 gray-border">
                                                    <label class="g-color-text g-font-weight-500 frame-label mb-1">Manufacturer: </label>
                                                    <span class="g-color-text frame-description mb-1">{{frame.manufacturer}} </span><br>
                                                    <label class="g-color-text g-font-weight-500 frame-label mb-1">Brand: </label>
                                                    <span class="g-color-text frame-description mb-1">{{frame.frameBrand}} </span>
                                                </div>
                                                <div class="text-center">
                                                    <button class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-mx-10 g-my-10" v-on:click="SelectFrameSuggestion(frame)">SELECT</button>
                                                </div>
                                            </article>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

      <div v-if="isFrameSizeModalShown">
        <div class="modal-mask" role="dialog">
          <div class="overlay-mask">
            <div class="modal-dialog modal-xl">
              <div class="modal-content">
                <div class="modal-body">
                  <div class="close_btn" v-on:click="CloseFrameSizeModal()"></div>
                  <div v-if="isFormLoading" class="row text-center">
                    <page-loader></page-loader>
                  </div>
                  <div v-else class="g-mt-20 g-mx-20">
                    <div>
                      <div class="container-fluid">
                        <h4>How to find frame measurements</h4>
                        <p>Providing accurate frame measurements helps the lab determine the best lens for the frame. Most frames will have the measurements printed inside one of the temples. You may also use a PD Ruler to collect the measurements yourself.If you are not able to provide these measurements, we will select default values for you but this may result in a thicker lens.</p>
                        <div class="row">
                          <div class="col-sm-12" style="max-width: 750px;">
                            <img src="../../../../../static/assets/img/FamilyImages/temple-size.png" style="width:100%; height:auto" alt="Temple size" />
                          </div>
                        </div>
                        <p>You may also use PDP Ruler to collect the measurement your self</p>
                        <div class="row">
                          <div class="col-sm-12" style="max-width: 750px;">
                            <img src="../../../../../static/assets/img/FamilyImages/frame-measurement.png" style="width:100%; height:auto" alt="Frame Measurement" />
                          </div>
                        </div>

                        <p>If you are not able to provide these measurements, we will select default values for you but this may result in a thicker lens.</p>
                        <div class="row">
                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center g-my-10">
                            <button class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-mx-10 g-my-10" v-on:click="CloseFrameSizeModal()">Close</button>
                          </div>
                        </div>
                      </diV>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import PageLoader from "@/components/shared/PageLoader";
import ParticipantAccountInformation from "@/components/portal/Order/OrderComponent/ParticipantAccountInformation";
export default {
  components: { Multiselect, PageLoader },
  props: [
    "Order",
    "ValidationResult",
    "Capping",
    "MasterAccountType",
    "isFrameLensServiceFee",
    "Account"
  ],
  data() {
    return {
      JobType: null,
      FrameType: null,
      FrameAndLens: [],
      CurrentFrameAndLens: null,
      FrameAndLensIndex: 0,
      isFalLoaded: false,
      currentJobType: null,
      framePageVisible: localStorage.getItem("frameAndLensOrderIsAllowed"),
      isModalShown: false,
      isFrameSizeModalShown: false,
      suggestedFrameList: [],
      isFormLoading: false,
      isChangeJobTypeDisabled: false,
    };
  },
  methods: {
    customLabel({ name, color, eyeSize, frameType, catalogId }) {
      return `Name/Model: ${name}  -  Color: ${color}  -  Eyesize: ${eyeSize}  -  Frame Type: ${frameType} -  Catalog: ${catalogId}`;
    },
    GetFrameInformation(portalUserSalesforceId) {
      var _this = this;
      axios
        .get("/Order/Catalog/ListJobType", { headers: { Authorization: "Bearer " + localStorage.getItem("token") }})
        .then(function(response) {
            // console.log("GET Order/Catalog/ListJobType");
            // console.log(response.data.raw);
          _this.JobType = response.data.raw;
          if(_this.framePageVisible == "false")
            _this.JobType = _this.RemoveFrameLens(_this.JobType);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    CheckVal(type) {
      if (this.isChangeJobTypeDisabled) return;
      this.Order.JobType = type;
      this.currentJobType = type;
    //   if ((type != "LSF") && (type != "UNC")) {
    //     this.Order.FrameManufacturer = "";
    //     this.Order.FrameModel = "";
    //     this.Order.FrameColor = "";
    //     this.Order.FrameEyeSize = "";
    //     this.Order.FrameTempleLength = "";
    //     this.Order.FrameType = "";
    //     this.Order.FrameId = 0;
    //     this.Order.FrameBrand = "";
    //     this.isFalLoaded = false;
    //   }
    },
    FrameAndLensValue(isSelectedSuggestedFrame) {
      this.Order.FrameProgramAssignments = this.CurrentFrameAndLens.frameProgramAssignments;
      this.Order.CatalogId = this.CurrentFrameAndLens.catalogId;
      this.Order.FrameManufacturer = this.CurrentFrameAndLens.manufacturer;
      this.Order.FrameModel = this.CurrentFrameAndLens.name;
      this.Order.FrameColor = this.CurrentFrameAndLens.color;
      this.Order.FrameEyeSize = this.CurrentFrameAndLens.eyeSize;
      this.Order.FrameTempleLength = this.CurrentFrameAndLens.templeLength;
      this.Order.FrameType = this.CurrentFrameAndLens.frameType;
      this.Order.FrameId = this.CurrentFrameAndLens.id;
      this.Order.FrameBrand = this.CurrentFrameAndLens.frameBrand;
      this.Order.FrameFpc = this.CurrentFrameAndLens.frameFpc;
      if (this.CurrentFrameAndLens.isOutOfStock) {
        this.GetFramesSuggestion(this.Order.FrameId);
        this.ShowModal();
      }
      else {
          if(!isSelectedSuggestedFrame){
            this.Order.OriginalFrameChoice = null;
            this.Order.SecondaryFrameChoice = null;
          }
      }
    },
    GetFrameAndLens(portalUserSalesforceId) {
      var _this = this;
      //var portalUserSalesforceId = localStorage.getItem("portalUserSalesforceId");
      axios
        .get("/Order/Catalog/ListFrameInformation" + "/" + portalUserSalesforceId, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
        .then(function(response) {
          _this.FrameAndLens = response.data.raw;
          if (_this.Order.JobType) {
            var frameIndex = _this.FrameAndLens.findIndex(
              x => x.id == _this.Order.FrameId
            );
            _this.CurrentFrameAndLens = _this.FrameAndLens[frameIndex];
            _this.FrameAndLensValue(true);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    GetFrameType() {
      var _this = this;
      axios
        .get("/Order/Catalog/ListFrame", {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
        .then(function(response) {
          _this.FrameType = response.data.raw;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    OpenHelpForm() {
      this.$emit("help");
    },
    ShowModal() {
      document.body.classList.add("body-overflow");
      this.isModalShown = true;
    },
    ShowFrameSizeModal() {
      document.body.classList.add("body-overflow");
      this.isFrameSizeModalShown = true;
    },
    CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    },
    CloseFrameSizeModal() {
      this.isFrameSizeModalShown = false;
      document.body.classList.remove("body-overflow");
    },
    GetFramesSuggestion(id) {
      var _this = this;
      this.isFormLoading = true;
      axios
        .post(
          "/Order/Catalog/ListFrameSuggestions",
          { id: id },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(function(response) {
          _this.suggestedFrameList = response.data.raw;
          _this.isFormLoading = false;
        })
        .catch(function(error) {
          console.log(error);
          _this.$router.push({ name: "Error" });
        });
    },
    SelectFrameSuggestion(frame) {
      this.Order.OriginalFrameChoice = this.CurrentFrameAndLens.id;
      this.Order.SecondaryFrameChoice = frame.id;
      var isSelectedSuggestedFrame = true;
      this.CurrentFrameAndLens = frame;
      this.FrameAndLensValue(isSelectedSuggestedFrame);
      this.CloseModal();
    },
    CloseOOSModal() {
      this.CurrentFrameAndLens = null;
      this.CloseModal();
    },
    ImageExists(_frame){
        // frames.forEach(frame => {
            _frame.frontImageURL = '../../../../../static/assets/img/evf-frame.png';
        // });
    },
    RemoveFrameLens(frames) {
        return frames.filter(e => e.id != 17);
    },
    ClickNoFrameMeasurements(){
      this.Order.FrameCheckMeasurements = !this.Order.FrameCheckMeasurements;
      if (this.Order.JobType =='FTC') {
        if (!this.Order.FrameCheckMeasurements) {
          this.Order.FrameEyeSize = null;
          this.Order.FrameDBL = null;
        } else {
          this.Order.FrameEyeSize = 57;
          this.Order.FrameDBL = 15;
        }
      }
      if (this.Order.JobType =='UNC') {
        if (!this.Order.FrameCheckMeasurements) {
          this.Order.FrameEyeSize = null;
          this.Order.FrameDBL = null;
          this.Order.FrameBBox = null;
          this.Order.FrameED = null;
        } else {
          this.Order.FrameEyeSize = 57;
          this.Order.FrameDBL = 15;
          this.Order.FrameBBox = 18;
          this.Order.FrameED = 58;
        }
      }
    }
  },
  watch: {
      Account(newAcct, oldAcct) {
          console.log("SelectedAccount watcher");
          console.log(oldAcct);
          console.log(newAcct);
          this.GetFrameAndLens(newAcct.portalUserSalesforceId);
      }
  },
  created() {
    var portalUserSalesforceId = localStorage.getItem("portalUserSalesforceId");
    if (this.Account) {
        console.log("Selected account is logged in: ", this.Account.portalUserSalesforceId === portalUserSalesforceId);
        portalUserSalesforceId = this.Account.portalUserSalesforceId;
    }
    console.log("Selected account: ", portalUserSalesforceId);
    if (this.Order.JobType === 'LSF' && this.Order.IsRemakeRedo) {
      this.isChangeJobTypeDisabled = true;
      this.Order.JobType = 'FTC';
    }
    this.GetFrameInformation(portalUserSalesforceId);
    this.GetFrameType();
    this.GetFrameAndLens(portalUserSalesforceId);
  }
};
</script>



// WEBPACK FOOTER //
// FrameInformation.vue?318f1699